module.exports = __webpack_public_path__ + "media/images/heason 2-862d181203e57a18a908a076e6139e6b.jpg";